import { Navigate } from "react-router-dom";

/** Emergent Google OAuth callback — retired. Clerk handles sign-in. */
export default function AuthCallback() {
  return <Navigate to="/" replace />;
}
